import { render, staticRenderFns } from "./UploadFileForm.vue?vue&type=template&id=16f49410"
import script from "./UploadFileForm.vue?vue&type=script&lang=js"
export * from "./UploadFileForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports